import * as React from 'react'
import { IBaseProduct, productName } from '@getgreenline/homi-shared'
import { Spin, Row, Col, Tag } from 'antd'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import { SmartImage } from '../../../../../components/SmartImage'
import ImagePlaceholder from '../../../../../../src/images/img-placeholder.svg'
import { Routes } from '../../../../../constants/Routes'
import { Link } from 'react-router'
import Highlighter from 'react-highlight-words'
import classnames from 'classnames'

interface Props {
  searchQuery?: string
  products: IBaseProduct[]
  className?: string
  isLoading?: boolean
}

interface InjectedProps {
  currentCompanyStore?: CurrentCompanyStore
}

export const SimilarProductList = inject('currentCompanyStore')(
  observer((props: Props & InjectedProps) => {
    const companyId = props.currentCompanyStore!.company!.id

    return (
      <div
        className='background-white ant-shadow'
        style={{
          position: 'absolute',
          top: 45,
          width: 'fit-content',
          minWidth: 287,
          maxWidth: '90vw',
          zIndex: 3,
        }}
        tabIndex={-1}
      >
        {props.isLoading ? (
          <Spin className='p-2' />
        ) : (
          props.products.length > 0 && (
            <div className={classnames('mb-0', props.className)} style={{ paddingTop: 15 }}>
              <label style={{ padding: '0 11px 11px 11px' }}>Similar products: </label>

              <Row
                style={{
                  overflow: 'scroll',
                  height: 'fit-content',
                  maxHeight: 300,
                }}
              >
                {props.products.map((product, key) => {
                  const productId = product.parentProductId ? product.parentProductId : product.id

                  return (
                    <Row key={key} className='d-flex flex-row' style={{ padding: '5px 11px' }}>
                      <Col className='mr-3'>
                        <SmartImage
                          src={product.imageUrl || ImagePlaceholder}
                          width={30}
                          height={30}
                        />
                      </Col>

                      <Col>
                        <Row className='text-wrap'>
                          <Link to={Routes.EDIT_PRODUCT(companyId, productId)} target='_blank'>
                            <span className='mr-2'>
                              {props.searchQuery === undefined ? (
                                productName(product)
                              ) : (
                                <Highlighter
                                  highlightClassName='highlighted-text'
                                  searchWords={[props.searchQuery]}
                                  autoEscape
                                  textToHighlight={productName(product)}
                                />
                              )}
                            </span>
                          </Link>

                          {product.isDeleted && <Tag color='red'>Deleted</Tag>}
                        </Row>

                        {product.sku && (
                          <Row className='text-wrap'>
                            <small>
                              <span>SKU: </span>
                              <b>
                                {props.searchQuery === undefined ? (
                                  product.sku
                                ) : (
                                  <Highlighter
                                    highlightClassName='highlighted-text'
                                    searchWords={[props.searchQuery]}
                                    autoEscape
                                    textToHighlight={product.sku}
                                  />
                                )}
                              </b>
                            </small>
                          </Row>
                        )}

                        {product.barcode && (
                          <Row className='text-wrap'>
                            <small>
                              <span>Barcode: </span>
                              <b>
                                {props.searchQuery === undefined ? (
                                  product.barcode
                                ) : (
                                  <Highlighter
                                    highlightClassName='highlighted-text'
                                    searchWords={[props.searchQuery]}
                                    autoEscape
                                    textToHighlight={product.barcode}
                                  />
                                )}
                              </b>
                            </small>
                          </Row>
                        )}
                      </Col>
                    </Row>
                  )
                })}
              </Row>
            </div>
          )
        )}
      </div>
    )
  }),
)
